import(/* webpackMode: "eager" */ "/app/src/app/(whithRootLayout)/opportunities/form/page.tsx");
